import React, {useEffect, useState} from "react";
import * as Yup from "yup";
import {Presentation} from "./Presentation";
import {FieldArray, Form, Formik} from 'formik';
import {useNavigate, useParams} from "react-router-dom";
import {LoaderEllipsisComponent} from "../../../components/elements/Loader/LoaderComponent";
import {PrimaryButton, SecondaryButton} from "../../../components/elements/Inputs/ButtonsComponents";
import {InputComponent, SelectComponent} from "../../../components/elements/Inputs";
import {Card, Typography} from "@material-tailwind/react";
import {INITIAL_VALUE_PRESENTATIONS, INITIAL_VALUE_PRICE, INITIAL_VALUES_FORM_PRODUCT} from "../../../utils/shared";


export function CreateProduct(props) {
  const {isView = false, isUpdate = false, item, retrieve, loader} = props;
  const [initialValues, setInitialValue] = useState(INITIAL_VALUES_FORM_PRODUCT)
  const [didMount, setMount] = useState(false)
  const nav = useNavigate()
  const {id} = useParams();

  useEffect(() => {
    setMount(true)
  }, []);

  useEffect(() => {
    if (id && didMount) {
      retrieve(id);
    }
  }, [id, didMount, retrieve]);

  useEffect(() => {
    if (id && didMount && item) {
      setInitialValue({...item, hasPresentation: !!item?.presentations?.length})
    }
  }, [id, didMount, item])

  const changeFormArray = (hasPresentation, setFieldValue) => {
    if (hasPresentation) {
      setFieldValue('prices', [])
      setFieldValue('presentations', [])
    } else {
      setFieldValue('prices', INITIAL_VALUE_PRICE)
      setFieldValue('presentations', [])
    }
  }

  const handleSubmit = (values) => {
    const newPresentationIfUndefined = values.presentations === undefined ? [] : values.presentations;
    const processedValues = {
      ...values,
      prices: [],
      presentations: newPresentationIfUndefined
    }
    if (id) {
      if (typeof values.image === 'object') {
        props.updateAttach(id, processedValues, nav)
      } else {
        delete processedValues.image;
        props.update(id, processedValues, nav)
      }
    } else {
      if (typeof values.image === 'object') {
        props.createAttach(processedValues, nav)
      } else {
        props.create(processedValues, nav)
      }
    }
  }

  const schemaProductWithOrWithoutPresentation = Yup.object().shape({
    name: Yup.string().required('Nombre de producto requerido'),
    category: Yup.string().required('Categoría requerida'),
    presentations: Yup.array().of(
      Yup.object().shape({
        name: Yup.string().required('Nombre de presentación requerido'),
        unit: Yup.string().required('Unidad requerida'),
        prices: Yup.array().of(
          Yup.object().shape({
            price_type: Yup.string().required('Debe de colocar un tipo de precio requerido'),
            amount: Yup.number().required('Debe de colocar un monto requerido'),
          })
        )
      }))
      .min(1, 'Mínimo una presentación'),
  });

  const goBack = () => nav('/producto');

  return (
    <>
      <Card className="py-5 h-full px-4 w-full border shadow-lg">
        <div className="w-full h-full">
          <LoaderEllipsisComponent loader={loader}/>
          <Formik
            enableReinitialize={true}
            validateOnMount={true}
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={schemaProductWithOrWithoutPresentation}
            component={({values, isValid, errors, touched}) =>
              <Form
                name="formPurchase">
                <div className="xl:lg:2xl:md:w-[60%] w-full mx-auto py-4">
                  <Typography className="font-bold text-black" variant="h4">
                    {isUpdate ? "Editar Producto" : isView ? `Producto ${id}` : "Crear Producto"}
                  </Typography>
                  <div className="pt-2 ">
                    <div className="grid grid-cols-1 xl:lg:2xl:md:grid-cols-2 xl:lg:2xl:md:gap-4 gap-2 justify-between mt-4">
                      <div className='col-span-1'>
                        <SelectComponent
                          name='category'
                          label='Categoría'
                          disabled={isView}
                          urlOptionList='/category/select_option'
                        />
                        <div className='col-span-1'>
                          <InputComponent
                            disabled={isView}
                            name={`name`}
                            label="Nombre del Producto"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="grid grid-cols-1 xl:lg:2xl:md:grid-cols-2 xl:lg:2xl:md:gap-4 gap-2 justify-between">
                      <div className='col-span-1'>
                        <InputComponent name='description' label='Descripción' type='textarea' disabled={isView}/>
                      </div>
                    </div>
                  </div>
                  {/*=========================================================================================*/}
                  {/*=========================================================================================*/}
                  {/*=========================================================================================*/}
                  <FieldArray
                    name="presentations"
                    validateOnChange={false}
                    render={(helpers) =>
                      <Presentation
                        isView={isView}
                        isUpdate={isUpdate}
                        {...helpers}
                        values={values}
                        errors={errors}
                        touched={touched}
                      />}
                  />
                  <ButtonsForm
                    isUpdate={isUpdate}
                    isView={isView}
                    isValid={isValid && !!values?.presentations?.length}
                    goBack={() => nav('/producto')}
                    submitForm={() => {
                    }}
                  />
                </div>
              </Form>
            }
          />
        </div>
      </Card>
    </>
  )
}

const ButtonsForm = ({goBack, isView, isUpdate, submitForm, isValid}) => {

  return (
    <div className="flex md:flex-row lg:flex-row flex-col justify-between gap-3 mt-6">
      <SecondaryButton
        type="button"
        text={'Regresar'}
        onClick={goBack}
      >
      </SecondaryButton>
      {
        !isView &&
        <PrimaryButton
          onClick={submitForm}
          text={isUpdate ? 'Actualizar' : 'Crear'}
          disabled={!isValid}
        >
        </PrimaryButton>
      }
    </div>
  )
}
